const titleBlankMessage: string = "Please enter a title"

export default class stringValidation {
	static validateTitle (title: string) {
		if (title == null || title.trim().length === 0) {
			return titleBlankMessage
		}
		return null
	}
}
